import { ReactElement } from "react";
import { motion } from "framer-motion"

import { Link } from "react-router-dom";


interface ListProps {
    selectId?: any
    items?: ListItemType[]
    setIsOpen?: (e?: boolean) => void
    isOpen?: boolean
    onClick?: (e?: ListItemType) => void
}


export const List = ({ ...props }: ListProps): ReactElement => {



    return (<nav>
        <ul className="">
            {props.items && props.items.map((item, index) => (
                <motion.li
                    onClick={() => { props.setIsOpen?.(props.isOpen) }}
                    key={index}
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ delay: index * 0.1 }}
                >
                    <Link
                        onClick={() => props.onClick?.(item)}
                        to={item.url || "#"}
                        className={
                            [
                                "flex items-center space-x-2 border-b p-2 transition-colors duration-300",
                                props.selectId !== item.id &&
                                "border-primary-600 text-primary-700 hover:bg-primary-100",
                                props.selectId === item.id &&
                                "bg-primary-100 text-primary-700 hover:bg-primary-200",
                            ]
                                .filter(Boolean)
                                .join(" ")
                        }
                    >
                        {item.icon && <item.icon className="h-5 w-5" />}
                        <span>{item.label}</span>
                    </Link>
                </motion.li>
            ))}
        </ul>
    </nav>);
} 